/**
 * Sales KPIs on the Overview tab - the board workbook's never-built
 * wishlist, computed live from the Schedule of Work: average price
 * per commissioned project, size-band mix, win rate and median time
 * to close. Trailing 12 months vs the 12 months before.
 */
import { useEffect, useState } from "react";
import axios from "axios";
import { PanelTitle } from "../staff/CommissionedPanels";
import { KpiStrip, InfoTip } from "./cfoShared";

const API = process.env.REACT_APP_BACKEND_URL;
const fmtW = (v) => (v == null ? "–" : `£${Math.round(v).toLocaleString("en-GB")}`);

const deltaBadge = (cur, prev, suffix = "") => {
  if (cur == null || prev == null || !prev) return "";
  const pct = (100 * (cur - prev)) / Math.abs(prev);
  return `${pct >= 0 ? "▲" : "▼"} ${Math.abs(pct).toFixed(0)}% vs prior 12m${suffix}`;
};

export default function SalesKpis() {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/api/proposals/pipeline/sales-kpis`)
      .then((r) => setData(r.data))
      .catch(() => setData(null));
  }, []);

  if (!data) return null;
  const cur = data.current || {};
  const prev = data.previous || {};
  const wr = data.win_rate || {};
  const ttc = data.time_to_close || {};
  const bands = cur.bands || {};

  return (
    <section data-testid="sales-kpis">
      <div className="mb-2">
        <PanelTitle>Sales KPIs · trailing 12 months <InfoTip id="ov_sales_kpis" /></PanelTitle>
      </div>
      <KpiStrip
        cards={[
          {
            label: "Avg price per project",
            value: fmtW(cur.avg_price),
            sub: deltaBadge(cur.avg_price, prev.avg_price) || "commissioned work",
            testid: "sales-kpi-avg-price",
          },
          {
            label: "Projects commissioned",
            value: `${cur.count ?? "–"}`,
            sub: `>£100k: ${bands.large ?? 0} · £10-100k: ${bands.medium ?? 0} · <£10k: ${bands.small ?? 0}`,
            testid: "sales-kpi-mix",
          },
          {
            label: "Win rate",
            value: wr.overall_pct != null ? `${wr.overall_pct}%` : "–",
            sub: wr.large_pct != null ? `>£100k quotes: ${wr.large_pct}% · quotes ≥90d old` : "quotes ≥90d old",
            testid: "sales-kpi-win-rate",
          },
          {
            label: "Median time to close",
            value: ttc.median_days != null ? `${ttc.median_days}d` : "–",
            sub: ttc.prev_median_days != null
              ? `quote → commissioned · prior 12m: ${ttc.prev_median_days}d`
              : "quote → commissioned",
            testid: "sales-kpi-time-to-close",
          },
        ]}
      />
    </section>
  );
}
